import React from 'react'
import SimpleTableTable from '../../../../../Components/SimpleTableTable'

const RosterMissionsTableView = ({
  header,
  data,
  sortOn,
  filterOn,
  postRowRender,
  searchOn,
  footerRender,
  action,
}) => {
  return (
    <SimpleTableTable
      header={header}
      data={data}
      filterOn={filterOn}
      sortOn={sortOn}
      postRowRender={postRowRender}
      searchOn={searchOn}
      footerRender={footerRender}
      showPages={false}
      action={action}
    />
  )
}

export default RosterMissionsTableView



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/RosterView/RosterMissionsTable/component/RosterMissionsTableView.js